import { createFileRoute, redirect } from "@tanstack/react-router";

// El esquema vive ahora en Configuración → Colecciones → Esquema.
export const Route = createFileRoute("/_authenticated/settings/_layout/schema")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/collections/schema", replace: true });
  },
});
